export const DEPLOYMENT_FEATURE_FLAG_NAME = 'mycs.deployment-downtime';
